import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDlCraN8YoORH-BRQqd8e4mR7a1DmU0ZI4",
  authDomain: "choretracker-fead6.firebaseapp.com",
  projectId: "choretracker-fead6",
  storageBucket: "choretracker-fead6.firebasestorage.app",
  messagingSenderId: "659776500529",
  appId: "1:659776500529:web:f6d9747dd96cd113fa7610"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
